{
  "ariaLabels": {
    "buttons": {
      "addToProfileBuilder": "add {name} to profile builder",
      "cancel": "cancel",
      "clearAllFilters": "clear all filters",
      "clearSearchInput": "clear search {name} input",
      "close": "close",
      "collapse": "collapse {name}",
      "contactCrux": "contact Crux",
      "copy": "copy {name}",
      "createDataProduct": "create data product",
      "delete": "delete {name}",
      "editDataset": "edit dataset",
      "editDatasetWithName": "edit dataset {name}",
      "editSchemaFieldname": "edit table schema fieldname {name}",
      "expand": "expand {name}",
      "filePatternCard": "view table schema {name}",
      "filter": "filter",
      "hidePassword": "hide password",
      "open": "open",
      "refreshDataProducts": "refresh data products table",
      "refreshHealthDashboard": "refresh health dashboard table",
      "refreshProfiler": "refresh remote directory",
      "remove": "remove {name}",
      "removeImage": "remove image",
      "saveImage": "save image",
      "showPassword": "show password",
      "supportChat": "start support chat",
      "toggleRightPanel": "{action} right panel",
      "unzipArchive": "unzip archive {name}",
      "viewCadence": "view Cadence",
      "viewDataset": "view dataset {name} details",
      "viewSchema": "view table schema {name} details"
    },
    "dropdowns": {
      "deactivateOrg": "deactivate org",
      "filter": "filter",
      "moreOptions": "more options"
    },
    "images": {
      "cruxLogo": "crux logo"
    },
    "inputs": {
      "search": "search {name}"
    },
    "links": {
      "backToDataProducts": "back to data products",
      "editDatasets": "edit datasets",
      "editDestinations": "edit destinations",
      "supplier": "supplier"
    },
    "navigation": {
      "create": "create organization navigation",
      "main": "main navigation",
      "scratch": "create data product navigation",
      "side": "side navigation"
    },
    "toggles": {
      "collapse": "collapse {name}",
      "expand": "expand {name}"
    }
  },
  "auth": {
    "form": {
      "title": "Welcome to Crux"
    },
    "login": "Log in",
    "pitch": "Crux helps companies reliably get the data they need, how they need it, where they need it.",
    "title": "Data Delivery{br}Simplified."
  },
  "badges": {
    "comingSoon": "Coming Soon",
    "gmt": "GMT"
  },
  "buttons": {
    "actions": "Actions",
    "activate": "Activate",
    "addChannel": "Add Channel",
    "addConnection": "Add Connection",
    "addEmail": "Add Email",
    "addMoreDataProducts": "Add More Data Products",
    "addOrganization": "Add Organization",
    "addPubSub": "Add Pub/Sub",
    "addSqs": "Add SQS",
    "addSubscribers": "Add Subscribers",
    "addSubscription": "Add Subscription",
    "addSubscriptions": "Add Subscriptions",
    "addUser": "Add User",
    "addWebhook": "Add Webhook",
    "apply": "Apply",
    "applyOverride": "Apply Override",
    "applySettings": "Apply Settings",
    "approve": "Approve",
    "back": "Back",
    "backToDirectory": "Back to Directory",
    "beginValidation": "Begin Validation",
    "browseFiles": "Browse Files",
    "browseSuppliers": "Browse Suppliers",
    "cancel": "Cancel",
    "cancelProfiling": "Cancel Profiling",
    "clear": "Clear",
    "clearAll": "Clear All",
    "clearChanges": "Clear Changes",
    "close": "Close",
    "configure": "Configure",
    "configureDataProducts": "Configure Data Products",
    "confirm": "Confirm",
    "connect": "Connect",
    "connectToDataSource": "Connect to Data Source",
    "contactCrux": "Contact Crux",
    "continue": "Continue",
    "continueProfiling": "Continue Profiling",
    "continueToOverride": "Continue to Override",
    "copyLogs": "Copy logs",
    "create": "Create",
    "createBackfill": "Create Backfill",
    "createConnection": "Create Connection",
    "createDataProduct": "Create Data Product",
    "createDataset": "Create Dataset",
    "createDestination": "Create Destination",
    "createFrame": "Create Frame",
    "createNewDataProduct": "Create a New Data Product",
    "createNotificationRule": "Create Notification Rule",
    "createOrg": "Create Organization",
    "customConnector": "Custom Connector",
    "deactivate": "Deactivate",
    "delete": "Delete",
    "deleteChannel": "Delete Channel",
    "deleteConnection": "Delete Connection",
    "deleteNotificationRule": "Delete Notification Rule",
    "deleteSubscription": "Delete Subscription",
    "deliverAllAsRaw": "Deliver All as Raw",
    "deliverAsRaw": "Deliver as Raw",
    "deliverRaw": "Deliver Raw",
    "deploy": "Deploy",
    "deployToTest": "Deploy to Test",
    "destinations": "Destinations",
    "dismiss": "Dismiss",
    "dontSave": "Don't Save",
    "downloadSample": "Download Sample",
    "downloadTemplate": "Download Template",
    "edit": "Edit",
    "editDataProduct": "Edit Data Product",
    "editDataset": "Edit Dataset",
    "editSchedule": "Edit Schedule",
    "editSettings": "Edit Settings",
    "editSubscription": "Edit Subscription",
    "entitle": "Entitle",
    "exclude": "Exclude",
    "existingConnection": "Existing Connection",
    "export": "Export",
    "exportAll": "Export All",
    "exportOdin": "Export ODIN",
    "filter": "Filter",
    "generateNewId": "Generate New ID",
    "getStarted": "Get Started",
    "goBack": "Go Back",
    "goToCruxStudio": "Go to Crux Studio",
    "goToEventConsole": "Go to Event Console",
    "import": "Import",
    "invite": "Invite",
    "learnAboutCruxForge": "Learn About Crux Managed",
    "learnMore": "Learn more",
    "leave": "Leave",
    "modelData": "Model Data",
    "nevermind": "Nevermind",
    "next": "Next",
    "nextDestinations": "Next: Destinations",
    "nextReview": "Next: Review & Export",
    "nextReviewAndDeploy": "Next: Review & Deploy",
    "nextSchedule": "Next: Schedule",
    "nextSelectData": "Next: Select Data",
    "nextTest": "Next: Test",
    "normalize": "Normalize",
    "notificationRules": "Notification Rules",
    "override": "Override",
    "pasteCron": "Paste CRON",
    "previewResults": "Preview Results",
    "profile": "Profile",
    "profileAll": "Profile All",
    "refineFilters": "Refine Filters",
    "remove": "Remove",
    "request": "Request",
    "removeSubscription": "Remove Subscription",
    "requestAccess": "Request Access",
    "retryDeployment": "Retry Deployment",
    "retryTestDeployment": "Retry Test Deployment",
    "returnToOrgs": "Return to Organizations",
    "save": "Save",
    "saveAndContinue": "Save and Continue",
    "saveChanges": "Save Changes",
    "saveImage": "Save Image",
    "saveSchedule": "Save Schedule",
    "schedule": "Schedule",
    "selectDestinations": "Select Destinations",
    "send": "Send",
    "skip": "Skip",
    "skipForNow": "Skip for Now",
    "skipProfilingAndDeliverRaw": "Skip Profiling and Deliver Raw",
    "skipToDestinations": "Skip to Destinations",
    "sort": "Sort",
    "submitRequest": "Submit Request",
    "testAndAddConnection": "Test and Add Connection",
    "tryAgain": "Try Again",
    "unarchiveSample": "Unarchive Sample",
    "unzip": "Unzip",
    "update": "Update",
    "updateConnection": "Update Connection",
    "updateNotificationRule": "Update Notification Rule",
    "updatePlan": "Update Plan",
    "upgradeNow": "Upgrade Now",
    "uploadNewFile": "Upload New File",
    "validateConfiguration": "Validate Configuration",
    "view": "View",
    "viewCadence": "View Cadence",
    "viewDataProducts": "Vew Data Products",
    "viewDetails": "View Details",
    "viewErrorDetails": "View Error Details",
    "viewFilesInGCS": "View Files in GCS",
    "viewLogs": "View Logs",
    "viewOdin": "View ODIN"
  },
  "catalog": {
    "helpText": "Don't see what you are looking for?"
  },
  "checks": {
    "All deliveries are unique check": "One or more files had an issue delivering",
    "All schedule periods have the expected number of deliveries": "Issue with the scheduled extractions",
    "Check delta content match raw": "Data validation of delivered files failed",
    "Successful deliveries number check": "Delivery of file failed"
  },
  "chirps": {
    "datasetUpdated": "Dataset updated.",
    "dataProductUpdated": "Data product updated",
    "notificationRuleDeleted": "Notification rule successfully deleted",
    "progressSaved": "Progress saved"
  },
  "connectionTrayDocumentation": {
    "badge": "{method}",
    "defaultBadge": "Documentation",
    "defaultConnectionTypeText": "connection",
    "helpText": "Once you select a {type} type you can preview all of the supporting documentation here.",
    "title": "Selecting a new {type}"
  },
  "contactCard": {
    "body": "Contact Crux and we will work with you to meet your project needs.",
    "link": "Contact Crux",
    "title": "Don't see a plan you are looking for?"
  },
  "errors": {
    "fetchLogs": "Failed to fetch logs. Please refresh the page to try again.",
    "invalidCronSchedule": "Invalid cron schedule",
    "service": "Service error.",
    "updateDataProduct": "There was an error updating the data product. Please try again."
  },
  "eventConsole": {
    "baseFilterOptionLabels": {
      "timeRange": "Time range",
      "type": "Event type"
    }
  },
  "forms": {
    "backfill": {
      "helpText": {
        "processObsoleteDelivery": "Enable if outdated deliveries are to be included."
      },
      "labels": {
        "backfillType": "Backfill Type",
        "cduId": "CDU ID",
        "datasetId": "Dataset ID",
        "deliveryId": "Delivery ID",
        "destinationId": "Destination ID / Delivery Dispatch Subscription ID",
        "endDate": "End Date",
        "processObsoleteDelivery": "Process Obsolete Delivery",
        "startDate": "Start Date"
      },
      "placeholders": {
        "backfillType": "Select a backfill type",
        "cduId": "Enter the CDU identifier",
        "datasetId": "Enter the dataset identifier",
        "deliveryId": "Enter the delivery identifier",
        "destinationId": "Enter the destination identifier",
        "endDate": "Select the last date to include",
        "startDate": "Select the first date to include"
      }
    },
    "dataset": {
      "helpText": {
        "productionReady": "Enable this option if the dataset is ready to be delivered."
      },
      "labels": {
        "afInstance": "Airflow Instance",
        "afVar": "Airflow Variable",
        "cronSchedule": "Cron Schedule",
        "description": "Dataset Description",
        "frequency": "Frequency",
        "name": "Dataset Name",
        "productionReady": "Production Ready",
        "status": "Status",
        "workflowId": "Workflow ID"
      },
      "placeholders": {
        "afInstance": "Airflow instance where this dataset will be run.",
        "afVar": "Name of the Airflow variable to use.",
        "cronSchedule": "Define how often the DAG should run using a cron expression.",
        "description": "A brief overview of the dataset.",
        "name": "Give this dataset a name.",
        "workflowId": "Workflow ID associated with this dataset."
      }
    },
    "frame": {
      "helpText": {
        "acceptsMultiple": "Enable if more than one file matching the pattern can be ingested.",
        "emptyFileOk": "Enable if an empty file is acceptable.",
        "optional": "Enable if the file is not required."
      },
      "labels": {
        "acceptsMultiple": "Accept Multiple Matching Files",
        "description": "Frame Description",
        "emptyFileOk": "Accept Empty File",
        "fetchedFile": "Fetched File",
        "frameGroup": "Frame Group",
        "frameId": "Frame ID",
        "name": "Frame Name",
        "optional": "Optional",
        "remotePath": "Remote Path",
        "unzippedFile": "Unzipped File",
        "workflowId": "Workflow ID"
      },
      "placeholders": {
        "description": "A brief overview of the frame.",
        "fetchedFile": "A file name or regex pattern describing which file(s) to fetch from the remote path.",
        "frameId": "Give this frame an ID. Usually the same as name.",
        "frameGroup": "Logical grouping identifier.",
        "name": "Give this frame a name.",
        "remotePath": "The location where the source files are expected to be found.",
        "unzippedFile": "The expected file name inside the fetched archive (if compressed).",
        "workflowId": "Workflow ID associated with this frame."
      }
    }
  },
  "healthDashboard": {
    "expectedDelivery": "Expected delivery",
    "errorCodeMessages": {
      "ACCESS_DENIED": "There was an error accessing this connection. Crux is working on addressing the issue.",
      "COLUMNS_MISMATCH_FAILURE": "There was an error processing the data due to a detected schema change from prior schema versions. Crux Data Operations team is working to resolve.",
      "CONNECTION_FAILURE": "There was an error ingesting data from the source due to invalid credentials. Crux is working with the supplier on your behalf.",
      "CONNECTION_EXCEPTION": "There was an error delivering your data due to a connectivity issue with your destination(s). Crux will check the connection and retry delivery attempt shortly.",
      "CRUX_CONNECTOR_FAILURE": "There was an error processing the data due to an internal adapter execution error. Crux Data Operations team is working to resolve.",
      "CRUX_INTERNAL_FAILURE": "There was an error delivering your data due to an internal issue. Crux is working on addressing the issue. We will retry the delivery attempt shortly.",
      "CRUX_NORMALIZER_FAILURE": "There was an error processing the data due to an internal adapter execution error. Crux Data Operations team is working to resolve.",
      "DATA_NOT_FOUND": "There was an error ingesting data from the source due to the remote path being unavailable on the remote server. Crux is working with the supplier on your behalf.",
      "DATA_QUALITY_FAILURE": "There was an error processing the data due to a suspected data quality issue. Crux is working with the supplier on your behalf.",
      "DEFAULT": "Something went wrong. Crux is working on addressing the issue as soon as possible.",
      "FILE_DOWNLOAD_FAILED": "There was an error downloading the file from the source. Crux is working with the supplier on your behalf.",
      "FILE_DOWNLOAD_INTERRUPTED": "There was an interruption when downloading the file from the source. Crux will check the connection and rerun the pipeline shortly.",
      "FILE_NOT_FOUND": "There was an error locating the file matching the expected file pattern at the source. Crux is working with the supplier on your behalf.",
      "INVALID_CODEC": "There was an error processing the data due to an unexpected file encoding for one or more files. Crux is working with the supplier on your behalf.",
      "INVALID_CONFIGURATION_PARAMETER": "There was an error processing the data due to an unexpected file format. Crux is working with the supplier on your behalf.",
      "INVALID_CREDENTIALS": "There was an error delivering your data due to invalid credentials with your destination(s). Crux is working on addressing the issue. We will retry the delivery attempt shortly.",
      "UNCLASSIFIED": "Something went wrong. Crux is working on addressing the issue as soon as possible.",
      "VALIDATION_DATATYPE_FAILURE": "There was an error processing the data due to a detected schema change involving inconsistent data types. Crux Data Operations team is working to resolve.",
      "VALIDATION_HEADER_FAILURE": "There was an error processing the data due to missing column headers in this schema version. Crux is working with the supplier on your behalf."
    },
    "status": {
      "FAILED": "Failed",
      "MISSING": "Missed",
      "DELIVERED_LATE": "Late",
      "HEALTHY": "Healthy",
      "UNKNOWN": "Unavailable"
    },
    "deliveryStepLabels": {
      "ingest": "Retrieved by Crux",
      "normalize": "Normalized by Crux",
      "process": "Processed by Crux",
      "dispatch": "Delivered to destination",
      "validate": "Validated by Crux"
    }
  },
  "imageAlts": {
    "dataProduct": "person looking at laptop",
    "lost": "person looking at papers",
    "runningFine": "person running looking at watch",
    "search": "person looking at magnifying glass",
    "wait": "person meditating"
  },
  "labels": {
    "channelDisplayName": "Channel display name",
    "dataProduct": "Data Product",
    "dataProductId": "Data Product ID",
    "dataProducts": "Data Products",
    "dataset": "Dataset",
    "datasetId": "Dataset ID",
    "datasets": "Datasets",
    "description": "Description",
    "destinations": "Destinations",
    "documentation": "Documentation",
    "does": "Does",
    "doesnt": "Doesn't",
    "email": "Email",
    "frames": "Frames",
    "importFromCsv": "Import from CSV",
    "is": "Is",
    "table": "Table",
    "tables": "Tables",
    "tablesCount": "Tables count",
    "metadata": "Metadata",
    "owner": "Owner",
    "parentheticalOptional": "(optional)",
    "name": "Name",
    "not": "Not",
    "orgContentMode": {
      "consumer": {
        "client": "My Subscriptions",
        "cruxer": "{org}'s Subscriptions"
      },
      "supplier": {
        "client": "My Publishings",
        "cruxer": "{org}'s Publishings"
      }
    },
    "singleBackfill": "Single Backfill",
    "singleDataset": "Single Dataset",
    "settings": "Settings",
    "subscribers": "Subscribers",
    "subscription": "Subscription",
    "support": "Support",
    "website": "Website"
  },
  "legal": [
    {
      "body": "You must agree to the Crux terms and conditions before using this application.",
      "label": "Crux Beta Test Agreement"
    },
    {
      "body": "This Crux Beta Test Agreement (the “Agreement”) is a legal agreement between you (either an individual or a single legal entity) and Crux Informatics, Inc., which covers your use of Crux’s software as a service (“SaaS”) and related software product (“Integrate”).\n\nIf you do not agree to the terms of this Agreement, then do not access, install or use the SaaS application or Integrate product. By explicitly accepting this Agreement you are acknowledging and agreeing to be bound by the following terms:",
      "label": "Important - Read Carefully"
    },
    {
      "body": "In consideration for Licensee’s agreement to and performance of the Licensee Obligations as outlined below, and subject to Licensee’s agreement to and compliance with the terms and conditions of this Agreement, CRUX hereby grants to Licensee and Licensee hereby accepts from CRUX a non-perpetual, non-exclusive, non-transferable and non-sublicensable license to access, execute, run, or otherwise interact with the Beta Product during the Beta Test Period (as defined below) for its own internal, non-production evaluation and testing only (the “Beta Test”). Licensee shall not make the Beta Product available directly or indirectly to any third party and shall not use it for the benefit of any third party. Ownership of and title to the Beta Product shall remain with CRUX at all times. Licensee will not represent or assert any ownership interest in the Beta Product.",
      "label": "License"
    },
    {
      "body": "The Beta Test Period is the thirty (30) day period beginning upon CRUX’s delivery to Licensee of the Beta Product, or such other period of time as may be agreed by the parties. However, in no event shall the Beta Test Period continue after CRUX withdraws the applicable Beta Product from testing.",
      "label": "Beta Test Period"
    },
    {
      "body": "The purpose of the Beta Test is for CRUX to obtain information from Licensee sufficient to determine the functionality, performance and usability of the Beta Program. Licensee agrees to use reasonable efforts to provide CRUX with comprehensive information regarding the Beta Products (“Feedback”) as soon as possible after Licensee learns of such Feedback. Feedback shall include, but is not limited to, all information regarding any problems or defects, security vulnerabilities, or other issues in the Beta Product encountered by Licensee. Licensee shall transmit Feedback to CRUX in any medium reasonably requested by CRUX, including via CRUX’s Internet customer support page, or by telephone, facsimile, or written or electronic communication. Feedback shall also include simplified test cases sufficient to adequately demonstrate problems or suspected errors Licensee encounters with the Beta Product. All Feedback shall become the sole and exclusive property of CRUX and may be used by CRUX in any way without restriction or obligation to Licensee. CRUX has an unconditional right to use for any purpose any ideas, concepts, know-how, or techniques resulting from CRUX’s access to or work with any Feedback or other information exchanged pursuant to this Agreement.",
      "label": "Licensee Obligations"
    },
    {
      "body": "CRUX reserves any and all rights, implied or otherwise, which are not expressly granted to Licensee hereunder, and retains all rights, title and interest in and to the Beta Product. Licensee agrees that it has no right whatsoever to modify the Beta Product or any portion thereof in any manner. Licensee may not reverse engineer, decompile, disassemble, modify, adapt, rent, lease, loan, create or prepare derivative works based upon the Beta Product or any part thereof. Nothing in this Agreement entitles Licensee to receive source code for any part of the Beta Product. Licensee may not (i) modify, translate, localize, adapt, rent, lease, loan, create or prepare derivative works of, or create a patent based on the Beta Product, or any part thereof, (ii) resell, provide, make available to, or permit use of or access to Beta Product or associated access credentials, by any third party; (iii) attempt to use or gain unauthorized access to CRUX’s or to any third-party’s networks or equipment; (iv) attempt to probe, scan or test the vulnerability of any CRUX services, or a system, account or network of CRUX or any CRUX customers or suppliers; (v) engage in fraudulent, offensive or illegal activity or intentionally engage in any activity that infringes the intellectual property rights or privacy rights of any individual or third party or transmit through any CRUX service any data or information without the legal right to do so; (vi) restrict, or knowingly inhibit, interfere or attempt to interfere with the ability of any other person, regardless of purpose or intent, to use or enjoy the CRUX services or a user’s network, or cause a performance degradation to any facilities used to provide the CRUX Services.",
      "label": "Restrictions"
    },
    {
      "body": "This Agreement or an individual license granted hereunder may be terminated (a) by mutual agreement of CRUX and Licensee, (b) by Licensee, upon five (5) days prior written notice to CRUX, and (c) by CRUX, for convenience or if Licensee breaches this Agreement and fails to cure such breach to CRUX’s reasonable satisfaction immediately upon CRUX’s notice thereof. Upon any termination of this Agreement or a license granted hereunder, Licensee shall immediately cease use of the applicable Beta Product and certify in writing to CRUX within thirty (30) days after termination that Licensee has destroyed or returned to CRUX such Beta Product and any copies thereof. Termination of this Agreement or a license granted hereunder shall not limit CRUX from pursuing any remedies available to it, including injunctive relief. The provisions of Sections 5, 7, 11 and 12 will survive termination of this Agreement.",
      "label": "Term And Termination"
    },
    {
      "body": " Licensee shall not export or re-export, or allow the export or re-export of the Beta Product or any copy, or portion thereof, in violation of any export laws, restrictions, national security controls or regulations of the United States or other applicable foreign agency or authority. Licensee’s access to Beta Product and related technology (the “Materials”) are for its own use, not for resale, export, re-export, or transfer. Licensee is subject to and responsible for compliance with the export control and economic sanctions laws of the United States and other applicable jurisdictions. Materials may not be used, sold, leased, exported, imported, re-exported, or transferred except as in compliance with such laws, including, without limitation, export licensing requirements, end-user, end-use, and end-destination restrictions, and prohibitions on dealings with sanctioned individuals and entities, including but not limited to persons on the Office of Foreign Assets Control’s Specially Designated Nationals and Blocked Persons List or the U.S. Department of Commerce Denied Persons List. Licensee represents and warrants that it is not the subject or target of, and that Licensee is not located in a country or territory (including without limitation, North Korea, Cuba, Iran, Syria, and Crimea) that is the subject or target of, economic sanctions of the United States or other applicable jurisdictions.",
      "label": "Export Law Assurances"
    },
    {
      "body": "“Confidential Information” shall be defined to include the Beta Product, Feedback, any software, source code, object code, documentation and any proprietary tools, proprietary knowledge or proprietary methodologies disclosed by CRUX to Licensee under this Agreement. Licensee shall observe complete confidentiality with respect to the Confidential Information, and shall use its best efforts and take all reasonable steps to protect such from any use, reproduction, publication, disclosure, or distribution except as specifically authorized by this Agreement. Licensee shall promptly notify CRUX of any known unauthorized use or disclosure of the Confidential Information and will cooperate with CRUX in any litigation brought by CRUX against third parties to protect its proprietary rights. Licensee may not permit a third-party access to, or use of, the Confidential Information without CRUX’s prior written authorization. Licensee agrees not to disclose to persons in its own organization who do not have a need to know the existence or contents of (i) the Beta Product(s); (ii) the Beta Test and its results, or (iii) this Agreement.",
      "label": "Confidential Information"
    },
    {
      "body": "CRUX shall have no obligation to support or provide support services to Licensee relating to the Beta Product. CRUX may, however, make such services available to Licensee at its sole discretion, including from time to time making available updates, enhancements and/or modifications to the Beta Product, but CRUX is under no obligation to do so. Any such updates, enhancements and/or modifications to the Beta Product shall be subject to the terms and conditions of this Agreement.",
      "label": "Technical Support"
    },
    {
      "body": "The Beta Product is a pre-release of a CRUX product that is not generally available for distribution at the time it is made available to Licensee and it is not intended for use in a production environment. The design of the Beta Product may be changed prior to general availability from CRUX without notice, and CRUX does not guarantee that compatibility of Licensee’s system can or will be maintained with versions of the Beta Product that may become generally available from CRUX. CRUX reserves the right to withdraw any Beta Product from Beta Testing and never release it as a commercial product. CRUX’s plans to market the Beta Product is subject solely to CRUX’s internal business and technical reviews. Nothing in this Agreement shall be deemed to convey to Licensee the right or license to use a commercially released version of the Beta Product or any components thereof. If and when a commercially released version of the Beta Product becomes available, any use by Licensee of such shall be subject to a separate written agreement between Licensee and CRUX and also subject to Licensee’s payment to CRUX of the applicable fees.",
      "label": "Beta Product Design and Commercial Availability"
    },
    {
      "body": "The Beta Product may not be at the level of performance, compatibility or safety of generally available CRUX products. Licensee understands and agrees that CRUX makes no representation or warranties regarding use of the Beta Product. Licensee shall have sole responsibility for adequate protection and backup of its data or equipment used in connection with the Beta Product and Licensee shall not claim against CRUX for lost data, re-run time, inaccurate input, work delays or lost profits resulting from the use of the Beta Product. THE BETA PRODUCTS AND TECHNICAL SUPPORT, IF ANY, ARE EXPERIMENTAL AND PROVIDED “AS IS” WITHOUT WARRANTY, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. COMPANY WILL USE THE PRODUCT AT ITS OWN RISK.",
      "label": "No Warranty"
    },
    {
      "body": "IN NO EVENT WILL CRUX OR ANY OF ITS AFFILIATES BE LIABLE FOR ANY DIRECT OR INDIRECT DAMAGES UNDER THIS AGREEMENT OR IN CONNECTION WITH THE BETA PRODUCT, INCLUDING BUT NOT LIMITED TO ANY LOST PROFITS, LOSS OF DATA, LOST SAVINGS OR ANY INCIDENTAL, PUNITIVE, SPECIAL, OR CONSEQUENTIAL DAMAGES OF ANY KIND, EVEN IF ADVISED OR AWARE OF THE POSSIBILITY OF SUCH DAMAGES, OR FOR ANY CLAIM BY LICENSEE BASED ON A THIRD PARTY CLAIM.",
      "label": "Limitation of Liability"
    },
    {
      "body": "This Agreement shall be governed by and construed in accordance with the laws of the State of California, without giving effect to any conflict of laws principles that would require the application of laws of a different state. The parties agree that the United Nations Convention on Contracts for the International Sale of Goods does not apply to this Agreement. Furthermore, the parties acknowledge that terms of the Uniform Computer Information Transaction Act (also known as UCITA) shall not apply to this Agreement, regardless of the states in which the parties do business or are incorporated. Any action seeking enforcement of this Agreement or any provision hereof shall be brought exclusively in the state or federal courts located in California. Each party hereby agrees to submit to the jurisdiction of such courts. If any provision of this Agreement shall be held by a court of competent jurisdiction to be contrary to law, that provision will be enforced to the maximum extent permissible and the remaining provisions of this Agreement will remain in full force and effect. The Beta Product is a “commercial item” under FAR 12.201. Consistent with FAR section 12.212 and DFARS section 227.7202, any use, modification, reproduction, release, performance, display, disclosure or distribution of the Beta Product by the U.S. government shall be governed solely by the terms of this Agreement and shall be prohibited except to the extent expressly permitted herein. Performance of any obligation required by a party hereunder may be waived only by a written waiver signed by an authorized representative of the other party, which waiver shall be effective only with respect to the specific obligation described therein. This Agreement constitutes the entire agreement between the parties regarding the subject matter hereof and supersedes all prior or contemporaneous agreements or representations, written or oral, concerning the subject matter of this Agreement. This Agreement may only be modified or amended by a writing executed by a duly authorized representative of each party. No other act, document, usage or custom shall be deemed to amend or modify this Agreement. This Agreement is legally binding only upon receipt of Licensee’s signature and upon counter-signature by a duly authorized representative of CRUX.\n\nThe parties have caused this Agreement to be executed by continuing to login and use the SaaS application and Integrate product and do each hereby warrant and represent that their respective acceptance by clicking “Agree” below is acceptance of this Agreement individually or is duly authorized by all necessary and appropriate corporate action to exercise this Agreement.",
      "label": "General"
    }
  ],
  "links": {
    "back": "Back"
  },
  "messages": {
    "actionCannotBeUndone": "This action cannot be undone.",
    "proceedQuestion": "Are you sure you want to proceed?"
  },
  "navigator": {
    "emptyStateText": "Please add/update filters."
  },
  "options": {
    "resolutionStatus": [
      {
        "label": "Fixed",
        "value": "fixed"
      },
      {
        "label": "Expected",
        "value": "expected"
      },
      {
        "label": "Investigating",
        "value": "investigating"
      },
      {
        "label": "No action needed",
        "value": "no_action_needed"
      }
    ]
  },
  "pages": {
    "dataProducts": {
      "title": "Pipeline Inventory"
    },
    "navigator": {
      "title": "Metadata Navigator"
    }
  },
  "placeholders": {
    "email": "Email",
    "emailAddress": "Email address",
    "enterEmail": "Enter your email",
    "enterPassword": "Enter your password",
    "name": "Name",
    "pubSubChannel": {
      "name": "Name your Pub/Sub channel",
      "topic": "projects/[PROJECT_ID]/topics/[TOPIC]"
    },
    "recipientName": "Enter recipient name",
    "searchLogs": "Search logs",
    "sqsChannel": {
      "name": "Name your Amazon SQS channel",
      "roleArn": "Eg., amazon-sqs-roleArn",
      "url": "Eg., https://sqs.mydomain.com/sqs"
    },
    "webhookChannel": {
      "name": "Name your webhook channel",
      "secretParameter": "Eg., very-secret-token",
      "webhookUrl": "Eg., https://webhook.mydomain.com/webhook"
    }
  },
  "pluralization": {
    "id": "ID | IDs",
    "dataset": "dataset | datasets",
    "tables": "{count} table | {count} tables",
    "thisThese": "this | these"
  },
  "studio": {
    "selectData": {
      "helpText": {
        "matchingFiles": "{count} matching file | {count} matching files",
        "noMatchingFiles": "No matching files"
      }
    },
    "test": {
      "helpText": "This step is optional if you wish to conduct data validation checks at a test destination before delivering data to production targets.",
      "title": "Test"
    },
    "review": {
      "title": "Review & export",
      "titleNext": "Review & deploy",
      "helpText": "Review your data product and export ODIN to activate your data product.",
      "helpTextNext": "Review your data product specifications and deploy to production."
    }
  },
  "toastMessages": {
    "channelSuccessMessage": "{type} channel {action} successfully.",
    "created": "created",
    "deleteConnectionFailureMessage": "Unable to delete this connection. It is being used by a data product.",
    "deleteConnectionSuccessMessage": "{type} connection deleted",
    "deleteDatasetsSuccessMessage": "{datasetsCount} {dataset} deleted",
    "deleted": "deleted",
    "duplicateNotificationChannel": {
      "email": "A notification channel with this email already exists. Enter a unique email and try again.",
      "pubSub": "A notification channel with this Pub/Sub Topic already exists. Enter a unique Topic value and try again.",
      "sqs": "A notification channel with this SQS URL already exists. Enter a unique SQS URL value and try again.",
      "webhook": "A notification channel with this webhook URL already exists. Enter a unique webhook URL value and try again."
    },
    "generateNewDatasetIdsSuccessMessage": "Generated new {id} for {datasetsCount} {dataset}",
    "heatmapFailure": "The history of extraction schedules failed to load.",
    "updated": "updated"
  },
  "tooltips": {
    "addFilenamePattern": "Add filename pattern",
    "collapse": "Collapse",
    "comingSoon": "Coming Soon",
    "delete": "Delete",
    "descending": "Descending",
    "discoverFilenamePatterns": "Discover filename patterns",
    "expand": "Expand",
    "gridLayout": "Grid layout",
    "listLayout": "List layout",
    "pubSubChannel": {
      "topic": "A fully qualified name of the Google Cloud Pub/Sub topic."
    },
    "refresh": "Refresh",
    "remove": "Remove",
    "sqsChannel": {
      "roleArn": "Your Amazon Resource Name(ARN) role for the queue.",
      "url": "URL identifying your Amazon SQS queue."
    },
    "webhookChannel": {
      "secretParameter": "A plain text value of the secret parameter.",
      "url": "The URL of the webhook POST endpoint."
    }
  },
  "values": {
    "na": "N/A"
  }
}
